<template>
  <div>
    <b-form-tags input-id="words" :value="wordTags" @input="update($event)" tag-pills tag-variant="primary" placeholder="Add keyword" />
    <div v-if="ignoredWords.length" class="my-2 text-small">
      Ignored words: 
      <b-link v-for="word in ignoredWords" :key="word.word" class="text-muted mr-1" @click="toggleIgnore(word)">
        {{word.word}}
      </b-link>
    <!-- <b-form-tags v-model="wordTags" no-outer-focus :disabled="$apollo.queries.words.loading">
      <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
          <b-form-tag
            pill
            v-for="tag in tags"
            @remove="removeTag(tag)"
            :key="tag"
            :title="tag"
            :variant="wordVariant(tag)"
            class="mr-1"
          >{{ tag }}</b-form-tag>
          <span class="b-from-tags-field d-inline-flex flex-grow-1">
            <div class="d-flex">
              <b-form-input
                v-bind="inputAttrs"
                v-on="inputHandlers"
                placeholder="Add keyword"
                class="b-form-tags-input w-100 flex-grow-1 p-0 m-0 bg-transparent border-0"
              ></b-form-input>
              <b-button @click="addTag()" variant="primary" class="b-form-tags-button py-0 btn-outline-secondary">Add</b-button>
            </div>
          </span>
      </template>
    </b-form-tags> -->
    </div>
  </div>
</template>
<script>
import QUERY_WORD_MUTATION from '@/graphql/QueryWordMutation.gql'
import DELETE_QUERY_WORD from '@/graphql/DeleteQueryWord.gql'

export default {
  name: 'KeywordInput',
  props: ['page', 'query_words'],

  data: () => {
    return {
      loading: false,
    }
  },

  computed: {
    wordTags() {
      return this.query_words
      .filter(e => e.score === null || e.score >= process.env.VUE_APP_WORD_CLICK_THRESHOLD)
      .filter(e => !e.ignored)
      .map(e => e.word)
    },
    ignoredWords() {
      return this.query_words.filter(e => e.ignored)
    }
  },

  watch: {
    page() {
      this.loading = false
    }
  },
  methods: {
    update(tags) {
      if (tags.length+1 == this.wordTags.length) {
        const removed = this.wordTags.find(e => !tags.includes(e))
        this.toggleIgnore({word: removed, ignored: false})
      } else {
        const added = tags[tags.length-1]
        this.addWord(added)
      }
    },
    async toggleIgnore(item) {
      this.loading = true
      if(item.id && !item.ignored) {
        await this.$apollo.mutate({
          mutation: DELETE_QUERY_WORD,
          variables: {id: item.id}
        })
      } else {
        await this.$apollo.mutate({
          mutation: QUERY_WORD_MUTATION,
          variables: {
            page_id: this.page.id,
            word: item.word,
            stem: item.stem || item.word.toLowerCase(),
            ignored: !item.ignored
          }
        })
      }
      const action = item.ignored ? 'Unmuted' : 'Muted'
      _zyppy.track(`Word ${action}`, {
        page_id: this.page.id,
        word: item.word,
        stem: item.stem,
      })
      this.$emit('refresh')
    },
    async addWord(newWord) {
      this.loading = true
      const item = {
        page_id: this.page.id,
        word: newWord,
        stem: newWord.toLowerCase(),
      }
      await this.$apollo.mutate({
        mutation: QUERY_WORD_MUTATION,
        variables: {
          ...item,
          ignored: false,
        }
      })
      _zyppy.track(`Word Added`, item)
      this.$emit('refresh')
    },
  }
}
</script>
